// easyui.module
// (c) 2017 EvoluS Srl
// (a) VG

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// importare i componenti specifici del modulo
import { EasyuiAccordionComponent } from './easyui-accordion.component';
import { EasyuiDatagridComponent } from './easyui-datagrid.component';
import { EasyuiTreegridComponent } from './easyui-treegrid.component';
import { EasyuiLayoutComponent } from './easyui-layout.component';
import { EasyuiDialogComponent } from './easyui-dialog.component';
import { EasyuiWindowComponent } from './easyui-window.component';
import { EasyuiLinkbuttonComponent } from './easyui-linkbutton.component';
import { EasyuiMenuButtonComponent } from './easyui-menubutton.component';
import { EasyuiSplitbuttonComponent } from './easyui-splitbutton.component';
import { EasyuiPanelComponent } from './easyui-panel.component';
import { EasyuiPopupMenuComponent } from './easyui-popup-menu.component';
import { EasyuiTabsComponent } from './easyui-tabs.component';
import { EasyuiDateboxComponent } from './easyui-datebox.component';
import { EasyuiComboboxComponent } from './easyui-combobox.component';
import { EasyuiCombogridComponent } from './easyui-combogrid.component';
import { EasyuiSelectComponent } from './easyui-select.component';
import { EasyuiToggleButtonComponent } from './easyui-toggle-button.component';
import { EasyuiErrorService } from './easyui-error.service';
import { EasyuiTextEditorComponent } from './easyui-texteditor.component';

@NgModule({
	declarations: [
		EasyuiAccordionComponent,
		EasyuiDatagridComponent,
		EasyuiTreegridComponent,
		EasyuiLayoutComponent,
		EasyuiDialogComponent,
		EasyuiWindowComponent,
		EasyuiLinkbuttonComponent,
		EasyuiMenuButtonComponent,
		EasyuiSplitbuttonComponent,
		EasyuiPanelComponent,
		EasyuiPopupMenuComponent,
		EasyuiTabsComponent,
		EasyuiDateboxComponent,
		EasyuiComboboxComponent,
		EasyuiCombogridComponent,
		EasyuiSelectComponent,
		EasyuiToggleButtonComponent,
		EasyuiTextEditorComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		EasyuiAccordionComponent,
		EasyuiDatagridComponent,
		EasyuiTreegridComponent,
		EasyuiLayoutComponent,
		EasyuiDialogComponent,
		EasyuiWindowComponent,
		EasyuiLinkbuttonComponent,
		EasyuiMenuButtonComponent,
		EasyuiSplitbuttonComponent,
		EasyuiPanelComponent,
		EasyuiPopupMenuComponent,
		EasyuiTabsComponent,
		EasyuiDateboxComponent,
		EasyuiComboboxComponent,
		EasyuiCombogridComponent,
		EasyuiSelectComponent,
		EasyuiToggleButtonComponent,
		EasyuiTextEditorComponent
	],
	providers: [
		EasyuiErrorService
	]
})
export class EasyuiModule { }



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui.module.ts